/**
 * Helper for Loadable to dynamically load components and split into webpack chunks
 */

import React, { Suspense } from "react";
import Loading from "../components/Loading/Loading"; // _platform

// Usage: const MyComponent = LoadAsync(() => import('./MyComponent'));
const LoadAsync = (loadFn) => {
  const LazyComponent = React.lazy(loadFn);

  // Return a component that wraps LazyComponent in Suspense
  return (props) => (
    <Suspense fallback={<Loading />}>
      <LazyComponent {...props} />
    </Suspense>
  );
};

export default LoadAsync;
